import { render, staticRenderFns } from "./listTessere.vue?vue&type=template&id=4f32f1e9&scoped=true&"
import script from "./listTessere.vue?vue&type=script&lang=js&"
export * from "./listTessere.vue?vue&type=script&lang=js&"
import style0 from "./listTessere.vue?vue&type=style&index=0&id=4f32f1e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f32f1e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VCardTitle,VContainer,VIcon,VImg,VRow,VSpacer,VTooltip})
